import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Fetches a page of bounced emails, newest first.
 * `lastSeen` is not an opaque cursor — it is the `email` of the last record of
 * the previous page. The endpoint has no hasMore/total, so the caller detects
 * "more pages" by comparing the returned length against `limit`.
 */
const getBouncedEmails = (limit, lastSeen, callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get('/ads/bounced-emails', {
            params: {
              'request-id': reqId,
              limit: limit || 50,
              ...(lastSeen ? { lastSeen } : {}),
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data || []);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch bounced emails');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback('Failed to fetch bounced emails');
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch bounced emails');
    }
  };
};

export default getBouncedEmails;
